import React, { useState } from 'react';

import * as styles from './index.module.scss';
import classNames from 'classnames';
import useIsMobile from '../../../hooks/useIsMobile';

enum MouseEvent {
  Enter = '1',
  Leave = '2',
}

enum Type {
  Validators,
  Investors,
  Team,
  Treasury,
  Tournament,
  Reserved,
}

const PieEchart = () => {
  const isMobile = useIsMobile();
  const [foucus1, setFocus1] = useState(false);
  const [foucus2, setFocus2] = useState(false);
  const [foucus3, setFocus3] = useState(false);
  const [foucus4, setFocus4] = useState(false);
  const [foucus5, setFocus5] = useState(false);
  const [foucus6, setFocus6] = useState(false);

  const mouseEvent = (type: Type, event: MouseEvent) => {
    switch (type) {
      case Type.Validators:
        if (event === MouseEvent.Enter) {
          setFocus1(true);
        } else {
          setFocus1(false);
        }
        break;
      case Type.Investors:
        if (event === MouseEvent.Enter) {
          setFocus2(true);
        } else {
          setFocus2(false);
        }
        break;
      case Type.Team:
        if (event === MouseEvent.Enter) {
          setFocus3(true);
        } else {
          setFocus3(false);
        }
        break;
      case Type.Treasury:
        if (event === MouseEvent.Enter) {
          setFocus4(true);
        } else {
          setFocus4(false);
        }
        break;
      case Type.Tournament:
        if (event === MouseEvent.Enter) {
          setFocus5(true);
        } else {
          setFocus5(false);
        }
        break;
      case Type.Reserved:
        if (event === MouseEvent.Enter) {
          setFocus6(true);
        } else {
          setFocus6(false);
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className={classNames(styles.echarts1)}>
      <div className={styles.title}>
        <img src="https://cdn-web.mtt.xyz/static/Frame%2048098470.png" alt="" />
        Token Allocation
      </div>
      {isMobile ? (
        <div className={styles.echartContentMobile}>
          <div className={styles.pie}>
            <img
              src="https://cdn-web.mtt.xyz/static/Group%201321314620.png"
              alt=""
            />
            {/* <div
              className={classNames(styles.middleHover, styles.middle1)}
              onMouseEnter={() => mouseEvent(Type.Validators, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Validators, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle2)}
              onMouseEnter={() => mouseEvent(Type.Investors, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Investors, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle3)}
              onMouseEnter={() => mouseEvent(Type.Team, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Team, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle4)}
              onMouseEnter={() => mouseEvent(Type.Treasury, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Treasury, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle5)}
              onMouseEnter={() => mouseEvent(Type.Tournament, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Tournament, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle6)}
              onMouseEnter={() => mouseEvent(Type.Reserved, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Reserved, MouseEvent.Leave)}
            /> */}
          </div>
          <div className={styles.infos}>
            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(255, 210, 126, 0.2)',
              }}
            >
              <label>40%</label>
              <span>Tournament Rewards</span>
            </div>

            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(168, 157, 255, 0.2)',
              }}
            >
              <label>15%</label>
              <span>Reserved</span>
            </div>

            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(94, 239, 187, 0.2)',
              }}
            >
              <label>15%</label>
              <span>Team</span>
            </div>

            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(86, 227, 254, 0.2)',
              }}
            >
              <label>15%</label>
              <span>Investors</span>
            </div>

            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(135, 176, 255, 0.2)',
              }}
            >
              <label>10%</label>
              <span>Validators Mining</span>
            </div>

            <div
              className={styles.infoItem}
              style={{
                backgroundColor: 'rgba(235, 83, 110, 0.2)',
              }}
            >
              <label>5%</label>
              <span>Treasury</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.echartContent}>
          <div className={styles.left}>
            <div
              style={{
                backgroundColor: `${
                  foucus1 ? 'rgba(135, 176, 255, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>10%</label>
              <span>Validators Mining</span>
            </div>
            <div
              style={{
                backgroundColor: `${
                  foucus2 ? 'rgba(86, 227, 254, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>15%</label>
              <span>Investors</span>
            </div>
            <div
              style={{
                backgroundColor: `${
                  foucus3 ? 'rgba(94, 239, 187, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>15%</label>
              <span>Team</span>
            </div>
          </div>
          <div className={styles.middle}>
            <img
              src="https://cdn-web.mtt.xyz/static/Group%201321314620.png"
              alt=""
            />
            <div
              className={classNames(styles.middleHover, styles.middle1)}
              onMouseEnter={() => mouseEvent(Type.Validators, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Validators, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle2)}
              onMouseEnter={() => mouseEvent(Type.Investors, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Investors, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle3)}
              onMouseEnter={() => mouseEvent(Type.Team, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Team, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle4)}
              onMouseEnter={() => mouseEvent(Type.Treasury, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Treasury, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle5)}
              onMouseEnter={() => mouseEvent(Type.Tournament, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Tournament, MouseEvent.Leave)}
            />
            <div
              className={classNames(styles.middleHover, styles.middle6)}
              onMouseEnter={() => mouseEvent(Type.Reserved, MouseEvent.Enter)}
              onMouseLeave={() => mouseEvent(Type.Reserved, MouseEvent.Leave)}
            />
          </div>
          <div className={styles.right}>
            <div
              style={{
                backgroundColor: `${
                  foucus6 ? 'rgba(235, 83, 110, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>5%</label>
              <span>Treasury</span>
            </div>
            <div
              style={{
                backgroundColor: `${
                  foucus5 ? 'rgba(255, 210, 126, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>40%</label>
              <span>Tournament Rewards</span>
            </div>
            <div
              style={{
                backgroundColor: `${
                  foucus4 ? 'rgba(168, 157, 255, 0.2)' : 'unset'
                }`,
              }}
            >
              <label>15%</label>
              <span>Reserved</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PieEchart;
